import { toast } from "react-toastify";
import { structure } from "./theme";

// Global toast
export const todoCompleted = () => {
  toast.success("Todo marked complete", structure);
};

export const todoUpdated = () => {
  toast.success("Todo updated successfully", structure);
};

export const todoInComplete = () => {
  toast.warn("Todo marked incomplete", structure);
};

export const todoAdded = () => {
  toast.success("Todo added successfully", structure);
};

export const fieldError = () => {
  toast.error("All fields are required", structure);
};

export const deleteSuccess = () => {
  toast.success("Todo deleted successfully", structure);
};